var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","tile":"","disabled":_vm.loading}},[_c('v-card-text',{staticClass:"pa-6"},[_c('al-project-form',{attrs:{"form-data":_vm.project}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }